import { Table, Space } from "antd";
import { useTranslation } from "react-i18next";
import ViewButton from "../UI/ViewButton/viewbutton";
import { UseMutateAsyncFunction } from "react-query";
import { AxiosResponse } from "axios";
import { Dispatch, useEffect } from "react";

interface inventoryProps {
  paginatedInventoriesDetails: any;
  isInventoriesDetailsLoading: boolean;
  InventoriesDetailsMutation: UseMutateAsyncFunction<
    AxiosResponse<any, any>,
    unknown,
    {
      id: number | string | undefined;
      search: string;
    },
    unknown
  >;
  setPaginatedInventoriesDetails: Dispatch<any>;
  search: string;
  id: string | undefined;
  tableKey: number;
}

const InventoryDetailsList = ({
  paginatedInventoriesDetails,
  isInventoriesDetailsLoading,
  InventoriesDetailsMutation,
  setPaginatedInventoriesDetails,
  search,
  id,
  tableKey,
}: inventoryProps) => {
  const [t] = useTranslation("common");

  useEffect(() => {
    InventoriesDetailsMutation({
      id,
      search: "",
    })
      .then((res) => {
        setPaginatedInventoriesDetails(res.data);
      })
      .catch((error) => {
        // Handle error
      });
  }, [InventoriesDetailsMutation, setPaginatedInventoriesDetails]);

  const columns = [
    {
      title: `${t("date")}`,
      dataIndex: "date",
      key: "date",
      widyh: "4rem",
      render: (record: number) => {
        const date = new Date(record * 1000);
        const formattedDate =
          date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear();
        return <Space size="middle">{formattedDate}</Space>;
      },
    },
    {
      title: `${t("source")}`,
      dataIndex: "source",
      key: "source",
    },
    {
      title: `${t("quantity")}`,
      dataIndex: "quantity",
      key: "quantity",
    },
    {
      title: `${t("unit-price")}`,
      dataIndex: "unitPrice",
      key: "unitPrice",
    },
    {
      title: `${t("tax")}`,
      dataIndex: "tax",
      key: "tax",
    },
    {
      title: `${t("discount")}`,
      dataIndex: "discount",
      key: "discount",
    },
    {
      title: `${t("total")}`,
      dataIndex: "total",
      key: "total",
    },
    {
      title: `${t("notes")}`,
      dataIndex: "notes",
      key: "notes",
    },
    {
      title: `${t("action")}`,
      key: "action",
      width: "4rem",
      align: "center" as "center",
      render: (record: any) => (
        <>
          <ViewButton onClick={() => ""} />
        </>
      ),
    },
  ];

  return (
    <>
      <Table
        key={tableKey}
        scroll={{ x: 1000 }}
        columns={columns}
        loading={isInventoriesDetailsLoading}
        dataSource={paginatedInventoriesDetails}
        rowClassName={(record, index) =>
          index % 2 === 0
            ? "table-row-light table-row"
            : "table-row-dark table-row"
        }
        rowKey={(record) => record.key}
      />
    </>
  );
};

export default InventoryDetailsList;
